import "./styles.scss";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Pagination from "../../components/Pagination";
import Filter from "../../components/elements/Filter";
import CardList from "../../components/elements/CardList";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import { getFilterTickets, getSubTypeID } from "../../store/middleware";
import { setCleanTicket } from "../../store/slices/customerService.slice";
import { getTicketMessages } from "../../store/middleware/customerService.middleware";

function CustomerServiceHomeCSCM() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user, language } = useSelector((state) => state.userReducer);
  const { tickets, ticketsInfo } = useSelector((state) => state.customerServiceReducer);

  const [filters, setFilters] = useState({
    id: "",
    requester: "",
    role: "",
    ticketTypeId: "",
    ticketSubTypeId: "",
    createdAt: "",
    status: "",
    creatorUserId: "",
    pageNumber: 1,
    pageSize: 10,
  });

  const HandlePagination = (page) => {
    filters["pageNumber"] = Number(page);
    setFilters(filters);
    ApplyFilters();
  };

  const InputChange = (e, name) => {
    const { value } = e.target;
    setFilters((state) => ({ ...state, [name]: value }));
    name === "ticketTypeId" && value !== "" && dispatch(getSubTypeID(value));
  };

  const ApplyFilters = () => {
    dispatch(getFilterTickets(filters, "list"));
  };

  const ResetFilter = async () => {
    await dispatch(
      getFilterTickets({
        id: "",
        requester: "",
        role: "",
        ticketTypeId: "",
        ticketSubTypeId: "",
        createdAt: "",
        status: "",
        creatorUserId: "",
        pageNumber: 1,
        pageSize: 10,
      }),
    );
    dispatch(setCleanTicket());
    setFilters({
      id: "",
      requester: "",
      role: "",
      ticketTypeId: "",
      ticketSubTypeId: "",
      createdAt: "",
      status: "",
      creatorUserId: "",
      pageNumber: 1,
      pageSize: 10,
    });
  };

  useEffect(() => {
    ResetFilter();
    // eslint-disable-next-line
  }, []);

  const newfilters = [
    { name: "id", value: filters.id, label: "TICKET_ID", placeholder: "ENTER_TICKET", type: "text" },
    {
      name: "requester",
      value: filters.requester,
      label: t("CREATOR_USER_ID"),
      placeholder: "ENTER_NAME",
      type: "text",
    },
    { name: "role", value: filters.role, type: "ticketProfiles" },
    { name: "ticketTypeId", value: filters.ticketTypeId, type: "ticketTypes" },
    { name: "ticketSubTypeId", value: filters.ticketSubTypeId, type: "ticketSubTypes" },
    { name: "createdAt", value: filters.createdAt, label: "OPEN_DATE", type: "date" },
    { name: "status", value: filters.status, type: "ticketStatus" },
  ];

  const listedTickets = tickets
    ? tickets.map((item) => {
        let ticketType = "";
        let ticketSubType = "";

        if (language === "en") {
          ticketType = item.ticketType.nameEnglish;
          ticketSubType = item.ticketSubType.nameEnglish;
        }
        if (language === "pt") {
          ticketType = item.ticketType.namePortuguese;
          ticketSubType = item.ticketSubType.namePortuguese;
        }
        if (language === "es") {
          ticketType = item.ticketType.nameSpanish;
          ticketSubType = item.ticketSubType.nameSpanish;
        }
        if (language === "fr") {
          ticketType = item.ticketType.nameSpanish;
          ticketSubType = item.ticketSubType.nameSpanish;
        }

        return {
          id: item.id,
          status: item.status,
          title: item.title,
          creatorUserId: decryptIfEncrypted(item.creatorUser.name),
          role: item.creatorUser?.role,
          type: ticketType,
          subType: ticketSubType,
          createdAt: item.createdAt,
          lastInteraction: item.updatedAt,
          timezone: user.timezone,
        };
      })
    : [];

  const listItems = [
    { label: "Ticket #", name: "id" },
    { label: t("STATUS"), name: "status" },
    { label: t("TITLE"), name: "title" },
    { label: t("CREATOR_USER_ID"), name: "creatorUserId" },
    { label: t("PROFILE"), name: "role" },
    { label: t("TYPE"), name: "type" },
    { label: t("SUBTYPE"), name: "subType" },
    { label: t("OPEN_DATE"), name: "createdAt" },
    { label: t("LAST_INTERACTION"), name: "lastInteraction" },
    { label: "", name: "button" },
  ];

  const handleTitketDetails = async (id) => {
    await dispatch(getFilterTickets({ ...filters, id: id }, "details"));
    await dispatch(getTicketMessages(id));

    window.location.href = "/customer-service/ticketDetail";
  };

  return (
    <div className="contentCSCM">
      <Filter
        filters={newfilters}
        inputChange={InputChange}
        clear={() => ResetFilter()}
        submit={() => ApplyFilters()}
      />
      <CardList
        listItems={listItems}
        listedItems={listedTickets}
        component="customer-service"
        action={(id) => handleTitketDetails(id)}
      />

      <Pagination
        totalFound={ticketsInfo?.pageSize}
        totalPages={ticketsInfo?.totalPages}
        pageCurrent={ticketsInfo?.pageNumber}
        totalResults={ticketsInfo?.totalFound}
        onClick={(page, type) => HandlePagination(page, type)}
      />
    </div>
  );
}

export default CustomerServiceHomeCSCM;
